export default [
  {
    path: 'users',
    component: () => import('@/views/users/components/UsersWrapper.vue'),
    children: [
      {
        path: '',
        name: 'users',
        component: () => import('@/views/users/UserSearch.vue'),
      },
      {
        path: '/users/new',
        name: 'newuser',
        component: () => import('@/views/users/manageUser/ManageUser.vue'),
      },
      {
        path: '/users/:userId?',
        name: 'edituser',
        component: () => import('@/views/users/manageUser/ManageUser.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          permissions: ['digitalsignature.security.userclient.visibility'],
        },
      },
    ],
  },
];
